/**
 * Mobile Menu - Submenu panel logic
 * Works alongside the existing HeaderDrawer in global.js
 */

document.addEventListener('DOMContentLoaded', function () {
  var backBtns = document.querySelectorAll('.drawer-submenu__back');

  backBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var details = btn.closest('.drawer-submenu__details');
      if (details) {
        details.removeAttribute('open');
      }
    });
  });
});
